module.exports = __webpack_public_path__ + "img/pnu_thumbnail.7a70b10f.jpg";